import { $api } from "../generated/client";

export default function useGetExportTasks(shopId: string, jobId: string) {
  return $api.useQuery("get", "/shops/{shopId}/exports/{exportId}", {
    params: { path: { shopId, exportId: jobId } },
  });
}
